import { jsx as _jsx } from "react/jsx-runtime";
import { Toolbar } from 'react-science/ui';
export function ToolBarButton(props) {
    return (_jsx(Toolbar, { children: _jsx(Toolbar.Item, { ...props }) }));
}
